import styles from './MainBanner.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import banner from '../../assets/banner/mainBanner2.png';
import mainBannerLeft from '../../assets/banner/mainBanner3.png';
import mainBannerRight from '../../assets/banner/mainBanner4.png';

const imsiSliderList = [banner];
function MainBanner() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperCore>();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.bannerSliderWrap}>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView={1}
          spaceBetween={0}
          className={styles.bannerSlider}
          onSlideChange={(e) => setActiveIdx(e.activeIndex)}
        >
          {imsiSliderList.map((banner, idx) => (
            <SwiperSlide key={idx} className={styles.slide}>
              <img src={banner} alt="banner" />
              <div className={styles.textOverlay}>
                <h1>Lighten your<br />everyday<br />with natural<br />vitality</h1>
                <button 
                  className={styles.shopNow}
                  onClick={() => navigate("/productList")}
                >
                  Shop Now
                </button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <ul className={styles.paginationWrap}>
          {imsiSliderList.map((banner, idx) => (
            <li
              key={idx}
              onClick={() => swiper?.slideTo(idx, 200)}
              className={idx == activeIdx ? styles.hit : ''}
            ></li>
          ))}
        </ul>
      </div>
      <div className={styles.textSection}>
        <div className={styles.stats}>
          <div>
            <h2>$35M</h2>
            <p>In research and <br /> development</p>
          </div>
          <div>
            <h2>100+</h2>
            <p>Global patents on <br /> our nutrition technology</p>
          </div>
          <div>
            <h2>32</h2>
            <p>Clinical trials - <br /> science you can trust</p>
          </div>
          <div>
            <h2>16</h2>
            <p>Prestigious University <br /> research partners</p>
          </div>
        </div>
      </div>
      <div className={styles.imageSection}>
        <div
          className={styles.imageBox}
          style={{
            backgroundImage: `url(${mainBannerLeft})`,
          }}
        >
          <h2>
            Ondoc offers trusted care, <br />
            rooted in nature
          </h2> 
          <p>
            We blend time-honored herbal wisdom with modern science <br />
            to bring you natural wellness solutions that fit your lifestyle.
          </p>
        </div>
        <div
          className={styles.imageBox}
          style={{
            backgroundImage: `url(${mainBannerRight})`,
          }}
        >
          <h2>
            Ondoc prescribes korean <br />
            medicine in many countries.
          </h2>
          <p>
            The United States, Thailand, Australia, Arab countries, etc. <br />
            Support for international services in six countries.
          </p>
        </div>
      </div>
    </div>
  );
}
export default MainBanner;
